var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2881_44956)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2881_44956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.671 14.6348H6.32818C5.19769 14.6348 4.28125 15.5512 4.28125 16.6817V41.9682C4.28125 43.0987 5.19769 44.0151 6.32818 44.0151H41.671C42.8015 44.0151 43.718 43.0987 43.718 41.9682V16.6817C43.718 15.5512 42.8015 14.6348 41.671 14.6348Z",
    fill: "#D1CEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7394 14.6348H6.32818C5.19769 14.6348 4.28125 15.5512 4.28125 16.6817V41.9682C4.28125 43.0987 5.19769 44.0151 6.32818 44.0151H39.7394C40.8699 44.0151 41.7864 43.0987 41.7864 41.9682V16.6817C41.7864 15.5512 40.8699 14.6348 39.7394 14.6348Z",
    fill: "#F7F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32818 14.6348H41.671C42.7968 14.6348 43.718 15.5559 43.718 16.6817V20.1557H4.28125V16.6817C4.28125 15.5559 5.20238 14.6348 6.32818 14.6348Z",
    fill: "#B3AEFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32818 14.6348H39.7394C40.8652 14.6348 41.7864 15.5559 41.7864 16.6817V20.1557H4.28125V16.6817C4.28125 15.5559 5.20238 14.6348 6.32818 14.6348Z",
    fill: "#766CF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01109 18.2409C9.47781 18.2409 9.85616 17.8626 9.85616 17.3959C9.85616 16.9291 9.47781 16.5508 9.01109 16.5508C8.54437 16.5508 8.16602 16.9291 8.16602 17.3959C8.16602 17.8626 8.54437 18.2409 9.01109 18.2409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4381 17.7229C13.6168 17.2917 13.4122 16.7972 12.9809 16.6184C12.5497 16.4397 12.0552 16.6443 11.8764 17.0756C11.6976 17.5068 11.9023 18.0014 12.3336 18.1801C12.7648 18.3589 13.2593 18.1542 13.4381 17.7229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2545 23.9121H8.96327C8.57473 23.9121 8.25977 24.2271 8.25977 24.6156V29.3253C8.25977 29.7139 8.57473 30.0288 8.96327 30.0288H17.2545C17.643 30.0288 17.958 29.7139 17.958 29.3253V24.6156C17.958 24.2271 17.643 23.9121 17.2545 23.9121Z",
    fill: "#F6D14F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8301 8.15H39.5156V5.35152C39.5156 4.93582 39.1754 4.5957 38.7597 4.5957H37.5859C37.1702 4.5957 36.8301 4.93582 36.8301 5.35152V8.15Z",
    fill: "#88FFC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8301 8.15H38.5498V5.35152C38.5498 4.93582 38.2096 4.5957 37.7939 4.5957H37.5859C37.1702 4.5957 36.8301 4.93582 36.8301 5.35152V8.15Z",
    fill: "#00D2A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5894 17.9462L39.9965 16.4904V7.70163C39.9965 7.44698 39.7888 7.23926 39.5341 7.23926H36.8139C36.5593 7.23926 36.3516 7.44698 36.3516 7.70163V16.4904L36.7586 17.9462V30.7772L38.174 34.5082L39.5894 30.7772V17.9462Z",
    fill: "#88FFC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5682 7.23926H36.8139C36.5593 7.23926 36.3516 7.44698 36.3516 7.70163V16.4904L36.7586 17.9462V30.7772L37.6911 33.2353L38.6236 30.7772V17.9462L39.0306 16.4904V7.70163C39.0306 7.44698 38.8229 7.23926 38.5682 7.23926Z",
    fill: "#00D2A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5894 17.9462L39.9965 16.4904V7.70163C39.9965 7.44698 39.7888 7.23926 39.5341 7.23926H36.8139C36.5593 7.23926 36.3516 7.44698 36.3516 7.70163V16.4904L36.7586 17.9462H39.5894Z",
    fill: "#88FFC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5682 7.23926H36.8139C36.5593 7.23926 36.3516 7.44698 36.3516 7.70163V16.4904L36.7586 17.9462H38.6236L39.0307 16.4904V7.70163C39.0307 7.44698 38.823 7.23926 38.5683 7.23926H38.5682Z",
    fill: "#00D2A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7578 30.7773L38.1733 34.5084L39.5886 30.7773H36.7578Z",
    fill: "#00D2A9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26065 39.7663C7.9495 39.7663 7.69727 39.514 7.69727 39.2029C7.69727 38.8918 7.9495 38.6395 8.26065 38.6395H23.9759C24.2871 38.6395 24.5393 38.8918 24.5393 39.2029C24.5393 39.514 24.2871 39.7663 23.9759 39.7663H8.26065ZM21.6822 24.4744C21.371 24.4744 21.1188 24.2222 21.1188 23.911C21.1188 23.5999 21.371 23.3477 21.6822 23.3477H26.3502C26.6613 23.3477 26.9136 23.5999 26.9136 23.911C26.9136 24.2222 26.6613 24.4744 26.3502 24.4744H21.6822ZM21.6822 27.5328C21.371 27.5328 21.1188 27.2805 21.1188 26.9694C21.1188 26.6582 21.371 26.406 21.6822 26.406H30.5353C30.8465 26.406 31.0987 26.6582 31.0987 26.9694C31.0987 27.2805 30.8465 27.5328 30.5353 27.5328H21.6822ZM21.6822 30.5911C21.371 30.5911 21.1188 30.3389 21.1188 30.0277C21.1188 29.7166 21.371 29.4644 21.6822 29.4644H32.4267C32.7378 29.4644 32.99 29.7166 32.99 30.0277C32.99 30.3389 32.7378 30.5911 32.4267 30.5911H21.6822ZM8.26065 33.6495C7.9495 33.6495 7.69727 33.3973 7.69727 33.0861C7.69727 32.775 7.9495 32.5227 8.26065 32.5227H28.1064C28.4176 32.5227 28.6698 32.775 28.6698 33.0861C28.6698 33.3973 28.4176 33.6495 28.1064 33.6495H8.26065ZM8.26065 36.7078C7.9495 36.7078 7.69727 36.4556 7.69727 36.1445C7.69727 35.8333 7.9495 35.5811 8.26065 35.5811H23.9759C24.2871 35.5811 24.5393 35.8333 24.5393 36.1445C24.5393 36.4556 24.2871 36.7078 23.9759 36.7078H8.26065Z",
    fill: "#909CD1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1091 17.9588C25.7979 17.9588 25.5457 17.7066 25.5457 17.3954C25.5457 17.0843 25.7979 16.832 26.1091 16.832H28.0407C28.3518 16.832 28.6041 17.0843 28.6041 17.3954C28.6041 17.7066 28.3518 17.9588 28.0407 17.9588H26.1091ZM21.6825 17.9588C21.3714 17.9588 21.1191 17.7066 21.1191 17.3954C21.1191 17.0843 21.3714 16.832 21.6825 16.832H23.6141C23.9253 16.832 24.1775 17.0843 24.1775 17.3954C24.1775 17.7066 23.9253 17.9588 23.6141 17.9588H21.6825ZM30.5357 17.9588C30.2246 17.9588 29.9724 17.7066 29.9724 17.3954C29.9724 17.0843 30.2246 16.832 30.5357 16.832H32.4673C32.7785 16.832 33.0307 17.0843 33.0307 17.3954C33.0307 17.7066 32.7785 17.9588 32.4673 17.9588H30.5357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.927 41.8967C27.0402 41.8967 26.6779 41.4354 26.5339 41.1224C25.8779 39.6928 27.7369 36.9451 29.2549 35.7549C30.7197 34.6063 31.6027 34.957 31.9987 35.2681C32.7793 35.8826 32.8577 37.2779 32.1927 38.7409C32.0228 39.1152 31.9312 39.3748 31.8812 39.55C32.154 39.4155 32.628 39.1191 33.445 38.479C33.5063 38.4313 33.556 38.3921 33.5932 38.3641C33.9505 38.0926 34.8493 37.5068 35.4781 37.9308C35.7315 38.1015 35.9905 38.4634 35.7846 39.218C35.745 39.363 35.7202 39.481 35.7058 39.5756C36.2932 39.0361 38.0198 37.9549 39.7461 37.9549C40.0565 37.9549 40.3094 38.207 40.3094 38.5182C40.3094 38.8293 40.0565 39.0815 39.7461 39.0815C38.4299 39.0815 36.955 39.9496 36.4584 40.4144C35.9599 40.8799 35.4184 41.0111 35.0094 40.7648C34.36 40.373 34.5653 39.4218 34.6746 39.007C34.5645 39.0629 34.4283 39.1447 34.2747 39.2615C34.241 39.2867 34.1959 39.3224 34.1393 39.3662C32.6226 40.5545 31.6205 41.1336 30.9908 40.5773C30.4454 40.0952 30.7526 39.1855 31.1674 38.275C31.6759 37.1554 31.548 36.3477 31.3016 36.1541C31.1344 36.0218 30.6786 36.0704 29.9496 36.6418C29.2758 37.1702 28.5566 38.0294 28.0721 38.884C27.5689 39.772 27.4529 40.423 27.5584 40.6519C27.6162 40.7787 27.9246 40.8066 28.344 40.7237C28.649 40.6631 28.9461 40.8614 29.0062 41.1667C29.0667 41.4716 28.8689 41.7684 28.5636 41.8289C28.3254 41.8762 28.1144 41.8968 27.927 41.8968V41.8967Z",
    fill: "#909CD1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6113 33.0387C37.6113 32.7288 37.8626 32.4775 38.1725 32.4775C38.4825 32.4775 38.7337 32.7288 38.7337 33.0387V35.108C38.7337 35.418 38.4825 35.6693 38.1725 35.6693C37.8626 35.6693 37.6113 35.418 37.6113 35.108V33.0387Z",
    fill: "#00D2A9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2881_44956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(4 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2881_44956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.2073,
    height: 41.2073,
    fill: "white",
    transform: "translate(3.39648 3.70215)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureIcon);
export default __webpack_public_path__ + "static/media/signature-icon.adb367394629c57d7833a5a503d1aebb.svg";
export { ForwardRef as ReactComponent };